/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect, useState } from 'react';
import Carousel from '@brainhubeu/react-carousel';
import { Card, Grid } from '@mui/material';

import '@brainhubeu/react-carousel/lib/style.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../assets/styles/components/banners';

import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import { saveStorege } from '../../helpers/db_storage';

const Banners: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();

  const [dataBanners, setDataBanners] = useState<any>();
  const [dataLocation, setDataLocation] = useState<any>();

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const handleListBanners = async () => {
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.indexPromotions({
          nr_operacao: 54,
          idMarketplace: dataLocation.idMarketplace,
        });
      setDataBanners(result.data);
    } catch (error) {
      toast.error('Ocorreu um erro ao buscar os queridinhos.');
    }
  };

  const handleSelectBanners = (data: any) => {
    switch (parseInt(data.idVinculo, 10)) {
      case 1:
        handleToPage(`list/shops/${window.btoa(data.idCategoria)}`);
        break;
      case 2:
        if (data?.idPromocao == '0') {
          handleToPage('/explore');
        } else {
          saveStorege(
            '@mais/delivery/shop/request/product/promotion',
            data.promocao[0],
          );
          handleToPage(
            `/shop/detail/list/product/subcategorie/${window.btoa(
              data.promocao[0].idRestaurante,
            )}/${window.btoa(data?.idPromocao)}/${window.btoa('promotion')}`,
          );
        }
        break;
      case 3:
        handleToPage(
          `shop/detail/list/product/subcategorie/${window.btoa(
            data.idRestaurante,
          )}`,
        );
        break;
      case 4:
        if (!data.cardapio.idCardapio) {
          return;
        }
        saveStorege('@mais/delivery/explore/product', {
          idCardapio: data.cardapio.idCardapio,
          idCategoria: data.cardapio.idCategoria,
          idSubCategoria: data.cardapio.idSubCategoria,
        });

        handleToPage(
          `/shop/detail/list/product/subcategorie/${window.btoa(
            data.idRestaurante,
          )}/${window.btoa(data.idCardapio)}/${window.btoa('explore')}`,
        );
        break;

      case 5:
        handleToPage(`fidelity/cashback`);

        break;

      case 6:
        handleToPage(`/fidelity/indicatewin`);

        break;

      case 7:
        handleToPage(`/fidelity/awardedorder`);
        break;

      case 8:
        break;

      case 9:
        handleToPage(`/fidelity/extract`);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (dataLocation?.idMarketplace) {
      handleListBanners();
    }
  }, [dataLocation]);

  useEffect(() => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    if (dataStorage?.idMarketplace) {
      setDataLocation(dataStorage);
    }
  }, []);

  return (
    <>
      {dataBanners?.length > 0 && (
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          padding="10px"
          className="darlings"
        >
          <Carousel
            animationSpeed={250}
            autoPlay={3500}
            infinite
            arrows
            breakpoints={{
              360: {
                arrows: false,
              },
              640: {
                arrows: false,
              },
            }}
          >
            {dataBanners.map((item: any) => (
              <Grid
                key={item.idBanner}
                onClick={() => handleSelectBanners(item)}
                className={classeStyle.card}
              >
                <img
                  className={classeStyle.img}
                  src={`${process.env.REACT_APP_API_IMG}${item.dsImagem}`}
                  alt="Banner"
                />
              </Grid>
            ))}
          </Carousel>
        </Grid>
      )}
    </>
  );
};
export default Banners;
